<template>
  <div>
    <!-- Pay -->
    <a-modal v-model="visible" title="Enrolled Student Details" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 360 : this.settings['isTabletView'] ? 560 : 1080"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
      </template>
      <a-spin :spinning="spinning">
      <div class="row">
        <div class="col-md-3">
          <p><span class="pr-2">Student's Code :</span> <span class="font-weight-bold px-2">{{enrolledStudent ? enrolledStudent.student_code : null}}</span></p>
        </div>
        <div class="col-md-5">
          <p><span class="pr-2">Student's Name :</span> <span class="font-weight-bold px-2">{{enrolledStudent ? enrolledStudent.full_name : null}}</span></p>
        </div>
        <div class="col-md-2">
          <p><span class="pr-2">Class :</span> <span class="font-weight-bold px-2">{{enrolledStudent ? enrolledStudent.class : null}}</span></p>
        </div>
        <div class="col-md-2">
          <p><span class="pr-2">Section :</span> <span class="font-weight-bold px-2">{{enrolledStudent ? enrolledStudent.section : null}}</span></p>
        </div>
      </div>
      <hr class="m-0">
        <div class="mb-2 mt-2">
          <p class="h6 text-muted">Registered Parents</p>
        </div>
        <table class="table table-borderless">
          <thead class="bg-light">
          <tr>
            <th width="50px">No.</th>
            <th width="100px">Name</th>
            <th width="100px">Email</th>
            <th width="100px">Phone</th>

<!--            <th class="text-right">Actions</th>-->
          </tr>
          </thead>
          <tbody>
            <tr v-for="(registeredparent, index) in enrolledStudent ? enrolledStudent.registered_parents : []"
                :key="registeredparent.id">
              <td>{{index + 1}}</td>
              <td>{{ registeredparent.name }}</td>
              <td>{{ registeredparent.email }}</td>
              <td>{{ registeredparent.phone }}</td>
            </tr>
          </tbody>
        </table>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'EnrolledStudentDetails',
  components: {
  },
  props: {
    isPublic: {
      default: false,
    },
    schoolData: {
      default: null,
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      registeredParent: null,
      enrolledStudent: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openViewEnrolledStudentDetailsModal', this.showModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
    showModal: function(enrolledStudent) {
      console.log('inside openViewEnrolledStudentDetailsModal')
      console.log('enrolled student:: ', enrolledStudent)
      this.visible = true
      // this.spinning = true
      this.enrolledStudent = enrolledStudent
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
